'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _shouldLogin = require('../../redux/modules/shouldLogin');

var _user = require('../../redux/modules/user');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propsComparer = require('../../utils/propsComparer');

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _redux = require('redux');

var _reactRedux = require('react-redux');

var _modal = require('../../redux/modules/modal');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _uuid = require('uuid');

var _uuid2 = _interopRequireDefault(_uuid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ShouldLogInContainer = (_dec = (0, _reactRedux.connect)(function (state) {
    var userLoggedIn = (0, _user.isUserLoggedIn)(state);
    var isCompleteProfile = (0, _user.isProfileComplete)(state);
    var triggerId = (0, _shouldLogin.getTriggerId)(state);
    var tracking = (0, _shouldLogin.isTracking)(state);
    var loginModalOpen = (0, _shouldLogin.isLoginModalOpen)(state);
    var completeAccountModalOpen = (0, _shouldLogin.isCompleteAccountModalOpen)(state);
    var confirmPasswordTriggered = (0, _user.isConfirmPasswordTriggered)(state);
    var userAtLeastPartiallyRegistered = (0, _user.isUserAtLeastPartiallyRegistered)(state);
    var userIsPartiallyRegistered = (0, _user.isUserPartiallyRegistered)(state);

    return {
        completeAccountModalOpen: completeAccountModalOpen,
        confirmPasswordTriggered: confirmPasswordTriggered,
        isCompleteProfile: isCompleteProfile,
        loginModalOpen: loginModalOpen,
        tracking: tracking,
        triggerId: triggerId,
        userAtLeastPartiallyRegistered: userAtLeastPartiallyRegistered,
        userIsPartiallyRegistered: userIsPartiallyRegistered,
        userLoggedIn: userLoggedIn
    };
}, function (dispatch) {
    return (0, _redux.bindActionCreators)({
        openCompleteAccountModalFromChecker: _shouldLogin.openCompleteAccountModalFromChecker,
        openConfirmPasswordModalFromChecker: _shouldLogin.openConfirmPasswordModalFromChecker,
        openCreateAccountModal: _modal.openCreateAccountModal,
        openLoginModalFromChecker: _shouldLogin.openLoginModalFromChecker,
        openSetPasswordModalFromChecker: _shouldLogin.openSetPasswordModalFromChecker,
        stopTracker: _shouldLogin.stopTracker
    }, dispatch);
}), _dec(_class = (_temp = _class2 = function (_Component) {
    (0, _inherits3.default)(ShouldLogInContainer, _Component);

    function ShouldLogInContainer(props, context) {
        (0, _classCallCheck3.default)(this, ShouldLogInContainer);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ShouldLogInContainer.__proto__ || (0, _getPrototypeOf2.default)(ShouldLogInContainer)).call(this, props, context));

        _this.determineModalFlow = function (userIsPartiallyRegistered) {
            if (userIsPartiallyRegistered) {
                _this.props.openSetPasswordModalFromChecker(_this.state.guid);
            } else {
                _this.props.openLoginModalFromChecker(_this.state.guid);
            }
        };

        _this.handleClick = function () {
            var _this$props = _this.props,
                forceConfirmPassword = _this$props.forceConfirmPassword,
                forceSignUp = _this$props.forceSignUp,
                userLoggedIn = _this$props.userLoggedIn,
                requireLogin = _this$props.requireLogin,
                isCompleteProfile = _this$props.isCompleteProfile,
                requireCompleteProfile = _this$props.requireCompleteProfile,
                requireUserAtLeastPartiallyRegistered = _this$props.requireUserAtLeastPartiallyRegistered,
                runFunction = _this$props.runFunction,
                runFunctionArgument = _this$props.runFunctionArgument,
                userIsPartiallyRegistered = _this$props.userIsPartiallyRegistered,
                userAtLeastPartiallyRegistered = _this$props.userAtLeastPartiallyRegistered;


            if (forceConfirmPassword) {
                _this.props.openConfirmPasswordModalFromChecker(_this.state.guid);
            } else if (forceSignUp) {
                _this.props.openCreateAccountModal();
            } else if (!userLoggedIn && requireLogin) {
                _this.determineModalFlow(userIsPartiallyRegistered);
            } else if (!isCompleteProfile && requireCompleteProfile) {
                _this.props.openCompleteAccountModalFromChecker(_this.state.guid);
            } else if (!userAtLeastPartiallyRegistered && requireUserAtLeastPartiallyRegistered) {
                _this.determineModalFlow(userIsPartiallyRegistered);
            } else {
                runFunction(runFunctionArgument);
            }
        };

        _this.state = { guid: _uuid2.default.v4() };
        return _this;
    }

    (0, _createClass3.default)(ShouldLogInContainer, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var _props = this.props,
                forceConfirmPassword = _props.forceConfirmPassword,
                requireLogin = _props.requireLogin,
                requireCompleteProfile = _props.requireCompleteProfile,
                runFunction = _props.runFunction,
                runFunctionArgument = _props.runFunctionArgument;
            var userLoggedIn = nextProps.userLoggedIn,
                isCompleteProfile = nextProps.isCompleteProfile,
                tracking = nextProps.tracking,
                loginModalOpen = nextProps.loginModalOpen,
                completeAccountModalOpen = nextProps.completeAccountModalOpen,
                triggerId = nextProps.triggerId;


            if (this.state.guid === triggerId && tracking) {
                if (forceConfirmPassword) {
                    if (this.props.confirmPasswordTriggered && this.props.confirmPasswordTriggered !== nextProps.confirmPasswordTriggered) {
                        this.props.stopTracker();
                        runFunction(runFunctionArgument);
                    }
                } else {
                    if (!loginModalOpen && !completeAccountModalOpen && (userLoggedIn || !requireLogin) && (isCompleteProfile || !requireCompleteProfile)) {
                        this.props.stopTracker();
                        runFunction(runFunctionArgument);
                    }

                    if (userLoggedIn && !loginModalOpen && requireCompleteProfile && !isCompleteProfile && !completeAccountModalOpen) {
                        this.props.openCompleteAccountModalFromChecker(triggerId);
                    }
                }
            }
        }
    }, {
        key: 'shouldUpdateComponent',
        value: function shouldUpdateComponent(nextProps) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['className', 'completeAccountModalOpen', 'confirmPasswordTriggered', 'forceConfirmPassword', 'forceSignUp', 'isCompleteProfile', 'loginModalOpen', 'requireCompleteProfile', 'requireLogin', 'runFunctionArgument', 'tracking', 'triggerId', 'userLoggedIn', 'children']);
        }
    }, {
        key: 'render',
        value: function render() {
            var className = this.props.className;

            return (0, _jsx3.default)('span', {
                className: className,
                onClick: this.handleClick
            }, void 0, this.props.children);
        }
    }]);
    return ShouldLogInContainer;
}(_react.Component), _class2.defaultProps = {
    className: '',
    loginModalOpen: false,
    requireCompleteProfile: false,
    requireLogin: true,
    tracking: false
}, _temp)) || _class);
exports.default = ShouldLogInContainer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ShouldLogIn/ShouldLogInContainer.js
// module id = iKXC
// module chunks = 46